import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../ProgressBar";
import { stepStyles } from "./formStyles";

export const WhatAreYouHopingToAchieve = ({ formData, setForm, navigation, step }) => {
  const loanReason = [
    { id: "Refinance", title: "Refinance" },
    { id: "Purchase", title: "Buy a Home" },
    { id: "Construction - Perm", title: "Build a Home" },
  ];

  // console.log(formData);
  // console.log(formData.loanReason);
  const [error, setError] = useState(false);
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const changePath = () => {
    if (formData.loanReason === "") {
      setError(true);
      console.log("error");
    }
    if (formData.loanReason === "Construction - Perm") {
      navigation.go(1);
    } else if (formData.loanReason === "Purchase") {
      navigation.go(11);
    } else if (formData.loanReason === "Refinance") {
      navigation.go(19);
    }
  };

  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"5%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>What are you hoping to achieve?</h1>
              <div className="w-full">
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">What are you hoping to achieve?</legend>
                  <div className={stepStyles.optionGroup}>
                    {loanReason.map((reason) => (
                      <label key={reason.id} className={stepStyles.optionRow}>
                        <input
                          onChange={setForm}
                          value={reason.id}
                          id={reason.id}
                          name="loanReason"
                          type="radio"
                          className={stepStyles.radio}
                        />
                        <span className={stepStyles.label}>{reason.title}</span>
                      </label>
                    ))}
                  </div>
                  {error ? <p className={stepStyles.error}>please fill out an answer</p> : null}
                </fieldset>
              </div>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => changePath()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
